export default __webpack_public_path__ + "static/media/inchLOGO.8d6db43d.png";